import styles from './styles.less';
import { observer } from 'mobx-react';


function TVEProvider(props) {
    const className = cx(styles.root, props.className, {
        [styles.invert]: props.invert
    })
    return (
        <div className={ className }>
            <img
                alt={ props.provider.name }
                className={ styles.image }
                src={ props.provider.image }
            />
            <button
                className={ styles.logoutButton }
                onClick={ props.onLogoutClick }>
                { props.logoutText }
            </button>
        </div>
    );
}

TVEProvider.propTypes = {
    invert: React.PropTypes.bool.isRequired,
    logoutText: React.PropTypes.string.isRequired,
    onLogoutClick: React.PropTypes.func.isRequired,
    provider: React.PropTypes.object.isRequired
};

TVEProvider.defaultProps = {
    invert: false,
    logoutText: 'Log out of watch'
};


export default observer(TVEProvider);



// WEBPACK FOOTER //
// ./src/common/components/tve-provider/index.js